import {customElement, bindable, inject} from 'aurelia-framework';
import {UserClient} from "../../../api/user-client";
import Client from "../../../api/client";

@customElement("sio-tab-overview")
@inject(UserClient, Client)
export class TabContentOverview {
    @bindable object;
    @bindable tab;

    constructor(userClient, client) {
        this.userClient = userClient;
        this.client = client;
    }


    tabChanged()
    {
        const panels = this.tab.preset.panels;

        this.leftColumn = [];
        this.rightColumn = [];

        const pinnedPanels = this.userClient.getUser()?.settings?.userSettings?.pinnedPanels ?? [];

        panels.forEach(panel => {

            const panelUniqueId = this.object.modelId + '/' + panel.id;

            panel.pinned = pinnedPanels.includes(panelUniqueId);

            if (panel.column === 'left') {
                this.leftColumn.push(panel);
            } else {
                this.rightColumn.push(panel);
            }
        });

        this.leftColumn.sort(function (a, b) {

            if (b.pinned === a.pinned) {
                return b.priority - a.priority;
            }

            return b.pinned - a.pinned;
        });

        this.rightColumn.sort(function (a, b) {
            if (b.pinned === a.pinned) {
                return b.priority - a.priority;
            }

            return b.pinned - a.pinned;
        });


        if (this.tab.layout === 'right-sided') {
            this.layoutIndex = [
                'col-xs-12 col-md-4',
                'col-xs-12 col-md-8'
            ]
        } else {
            this.layoutIndex = [
                'col-xs-12 col-md-6',
                'col-xs-12 col-md-6'
            ]
        }
    }

    onPinChange(panel, pinned) {
        const pinnedPanels = this.userClient.getUser()?.settings?.userSettings?.pinnedPanels ?? [];
        const panelId = this.object.modelId + '/' + panel.id;

        if (pinned) {
            if (pinnedPanels.indexOf(panelId) === -1) {
                pinnedPanels.push(panelId);
            }
        } else if (pinnedPanels.indexOf(panelId) > -1) {
            pinnedPanels.splice(pinnedPanels.indexOf(panelId), 1);
        }

        this.client.put(
            `user/settings-pinned-panels/${this.userClient.getUser().id}`,
            {
                settings: {userSettings: {pinnedPanels: pinnedPanels}},
            }
        );

        this.tabChanged();
    }
}
